import { QueryHookOptions, useQuery } from '@apollo/client'
import B2C_GET_OPEN_ORDERS from '@graphql/queries/getOpenOrders.query'
import { B2CGetOpenOrdersQuery, B2CGetOpenOrdersQueryVariables } from 'parkdepot-shared/gql/graphql'

const useGetOpenOrders = (opts: QueryHookOptions<B2CGetOpenOrdersQuery, B2CGetOpenOrdersQueryVariables>) => {
    return useQuery(B2C_GET_OPEN_ORDERS, opts)
}

export default useGetOpenOrders
